function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group 4");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-180.000000, -38.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(61.000000, 38.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(119.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#FEB913"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 26,
  r: 26
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(15.000000, 23.000000)",
  fill: "#5C5E65",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14,3 C14,4.6570603 12.6570933,6 11,6 C9.34290674,6 8,4.65709326 8,3 C8,1.34290674 9.34290674,0 11,0 C12.6570933,0 14,1.34290674 14,3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6,3 C6,4.64806188 4.64777217,6 2.99935712,6 C1.35094207,6 0,4.64806188 0,3 C0,1.35193812 1.35222783,0 3.00064288,0 C4.64777217,0 6,1.35193812 6,3 Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.0006429,6 C17.3432275,6 16,4.65709326 16,3 C16,1.34290674 17.3431945,0 19.0006429,0 C20.6567725,0 22,1.34290674 22,3 C22,4.6570603 20.6568055,6 19.0006429,6 Z"
}))))));

var SvgRespondOther = function SvgRespondOther(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRespondOther, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/respond_other.b88cdcf8.svg";
export { ForwardRef as ReactComponent };